import res from './res'

res.add('kk', {
    title: 'Кестені орнату',
    rowsCount: 'Беттегі жолдар саны:',
    fieldsSettings: 'Бағандарды көрсету ретін реттеу',
    applyButton: 'Сақтау',
    cancelButton: 'Бас тарту'
})
